function generateJsxKey(context) {
  return `${context.depth}-${context.index}`;
}

export { generateJsxKey };
//# sourceMappingURL=util.generate-jsx-key.js.map
